import { Link } from "react-router-dom";
import { formatDate, formatTime } from "../util/api";

export default function PatientTable({ appointments }) {
  return (
    <>
      <style>{`
        .appt-wrapper {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
          gap: 20px;
          padding: 10px;
        }

        .appt-card {
          background: #ffffff;
          border-radius: 18px;
          padding: 18px;
          box-shadow: 0 15px 40px rgba(0,0,0,0.08);
          transition: all 0.3s ease;
          display: flex;
          flex-direction: column;
          gap: 12px;
          animation: fadeUp 0.6s ease;
        }

        .appt-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 20px 50px rgba(0,0,0,0.12);
        }

        .appt-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .appt-date {
          font-size: 13px;
          color: #6c757d;
        }

        .status {
          padding: 6px 14px;
          border-radius: 30px;
          font-size: 12px;
          font-weight: 600;
          text-transform: capitalize;
        }

        .status.completed {
          background: rgba(40,167,69,0.12);
          color: #28a745;
        }

        .status.pending {
          background: rgba(255,193,7,0.15);
          color: #856404;
        }

        .status.cancelled {
          background: rgba(220,53,69,0.15);
          color: #dc3545;
        }

        .appt-body {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }

        .appt-row {
          font-size: 14px;
          display: flex;
          justify-content: space-between;
        }

        .appt-row span {
          font-weight: 600;
          color: #212529;
        }

        .appt-footer {
          margin-top: auto;
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 10px;
          flex-wrap: wrap;
        }

        .action-btn {
          background: linear-gradient(135deg, #28a745, #20c997);
          color: white;
          padding: 8px 16px;
          border-radius: 30px;
          font-size: 13px;
          font-weight: 600;
          text-decoration: none;
          transition: 0.3s ease;
          white-space: nowrap;
        }

        .action-btn:hover {
          opacity: 0.9;
          color: #fff;
        }

        .message-badge {
          background: #dc3545;
          color: #fff;
          border-radius: 20px;
          padding: 4px 10px;
          font-size: 12px;
          font-weight: 600;
          display: inline-flex;
          align-items: center;
          gap: 5px;
        }

        @keyframes fadeUp {
          from {
            opacity: 0;
            transform: translateY(15px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>

      <div className="appt-wrapper">
        {appointments.map((row, index) => (
          <div className="appt-card" key={index}>
            <div className="appt-header">
              <div className="appt-date">
                Created: {formatDate(row.created_at) || " "}
              </div>

              <div
                className={`status ${
                  row.status === "completed"
                    ? "completed"
                    : row.status === "cancelled"
                    ? "cancelled"
                    : "pending"
                }`}
              >
                {row.status}
              </div>
            </div>

            <div className="appt-body">
              <div className="appt-row">
                <div>Appointment ID:</div>
                <span>{row.id || "N/A"}</span>
              </div>
              
              <div className="appt-row">
                <div>Lawyer</div>
                <span>{row.doctor.name || " "}</span>
              </div>

              <div className="appt-row">
                <div>Booked</div>
                <span>
                  {row.day} {formatTime(row.starttime)} –{" "}
                  {formatTime(row.endtime)}
                </span>
              </div>
            </div>

            <div className="appt-footer">
              {row.status === "pending" ? (
                <Link
                  to={`/payment_options/${row.id}`}
                  className="action-btn"
                >
                  Make Payment
                </Link>
              ) : (
                <Link
                  to={`/appointment/${row.id}`}
                  className="action-btn"
                >
                  View Details
                </Link>
              )}

              {row.unseen_chat_box_count > 0 && (
                <Link to={`/appointment/${row.id}`}>
                  <span className="message-badge">
                    ✉️ {row.unseen_chat_box_count}
                  </span>
                </Link>
              )}
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
